import { NgModule } from '@angular/core';
import { FormControlPipe } from './form-transform.pipe';
import { HourPipe } from './hours.pipe';
import { TimeShortPipe } from './time-short.pipe';

@NgModule({
  imports: [
    FormControlPipe,
    HourPipe,
    TimeShortPipe
  ],
  declarations: [ 
  ],
  exports: [
    FormControlPipe,
    HourPipe,
    TimeShortPipe
  ]
})
export class PipesModule {}